import React, {useEffect, useState} from "react";
import "./LoginPage.css";
import { apiFetch as fetch } from "apiClient";

function LoginPage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const loginEnabled = username.trim().length > 0 && password.trim().length > 0;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        const u = username.trim();
        const p = password.trim();

        if (!u || !p) {
            setError("Please enter both username and password.");
            return;
        }

        setLoading(true);
        try {
            const res = await fetch("/api/app/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username: u, password: p }),
            });
            const data = await res.json();

            if (!res.ok || !data.success) {
                setError(data.message || "Login failed");
                setLoading(false);
                return;
            }

            window.location.href = "/dashboard";
        } catch (err) {
            console.error("Login error", err);
            setError("Unexpected error. Please try again.");
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-card">
                <div className="login-card-header">
                    <div className="login-logo-circle">
                        <span className="login-logo-text">AT</span>
                    </div>
                    <div>
                        <h1 className="login-title">Terminal Login</h1>
                        <p className="login-subtitle">
                            Sign in to access your trading workspace
                        </p>
                    </div>
                </div>

                {error && <div className="login-error">{error}</div>}

                <form className="login-form" onSubmit={handleSubmit}>
                    <div className="login-field">
                        <label className="login-label" htmlFor="username">
                            Username
                        </label>
                        <input
                            id="username"
                            type="text"
                            className="login-input"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            autoComplete="username"
                            autoFocus
                        />
                    </div>

                    <div className="login-field">
                        <label className="login-label" htmlFor="password">
                            Password
                        </label>
                        <input
                            id="password"
                            type="password"
                            className="login-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"
                        />
                    </div>

                    <button
                        id="login-button"
                        type="submit"
                        className="login-button"
                        disabled={!loginEnabled || loading}   // 👈 no username/password here
                    >
                        {loading ? "Logging in..." : "Login"}
                    </button>
                </form>

            </div>
        </div>
    );
}

export default LoginPage;
